module.exports = __webpack_public_path__ + "img/souko_circle.bac529a.svg";